import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const ServiceSelectPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selected, setSelected] = useState(location.state?.tab || '');

  const services = [
    {
      id: 'verify',
      icon: '🔍',
      title: '현장 검증 서비스',
      subtitle: '구매 전 직접 확인',
      desc: '영차매니저가 판매자 현장에 직접 방문하여 상품 상태를 꼼꼼히 검증합니다. 하자 발견 시 검증비(15,000원)만 지불하고 구매를 취소할 수 있어요.',
      price: '검증비 15,000원~',
      features: ['현장 방문 사진 전송', '하자 체크리스트 작성', '기본 세척 서비스', '구매 취소 시 검증비만'],
      color: '#27AE60',
      bgColor: '#e8f8ef',
      badge: '추천',
      estimatedTime: '1~2시간',
    },
    {
      id: 'delivery',
      icon: '🚚',
      title: '용달 배송 서비스',
      subtitle: '안전하고 빠른 배송',
      desc: '검증이 완료된 가구를 내 집까지 안전하게 배송해 드립니다. 투명한 요금제로 합리적인 배송비를 보장합니다.',
      price: '기본 10,000원 + km당 2,000원',
      features: ['투명 거리 요금제', '포장 서비스 제공', '엘리베이터/계단 포함', '배송 실시간 추적'],
      color: '#2980B9',
      bgColor: '#e8f4fd',
      badge: null,
      estimatedTime: '당일 배송 가능',
    },
    {
      id: 'verify_delivery',
      icon: '🎯',
      title: '검증 + 배송 패키지',
      subtitle: '가장 많이 선택하는 서비스',
      desc: '현장 검증부터 배송까지 한 번에 해결! 검증 후 이상 없으면 바로 배송, 문제 있으면 검증비만 내면 됩니다.',
      price: '패키지 특가',
      features: ['검증 + 배송 일괄 처리', '가장 빠른 서비스', '실시간 알림 제공', '배송 완료 후 설치 안내'],
      color: '#FF6B35',
      bgColor: '#fff0eb',
      badge: '인기',
      estimatedTime: '2~4시간 내 완료',
    },
    {
      id: 'truck',
      icon: '🛣️',
      title: '공차 매칭',
      subtitle: '이사 귀환 차량 활용',
      desc: '이사 완료 후 귀환하는 용달차를 활용해 최대 50% 저렴하게 배송받으세요. 지방에서 올라오는 차량도 매칭 가능!',
      price: '일반 대비 최대 50% 절약',
      features: ['귀환 공차 특가 이용', '지방 물건 서울 배송', '실시간 차량 위치 확인', '대형 물품 가능'],
      color: '#8E44AD',
      bgColor: '#f3e5f5',
      badge: '절약',
      estimatedTime: '차량 도착 시간 기준',
    },
  ];

  const handleSelect = (id) => {
    setSelected(id);
  };

  const handleNext = () => {
    if (!selected) return;
    if (selected === 'truck') {
      navigate('/truck-match');
    } else {
      navigate('/ai-analysis', { state: { serviceType: selected } });
    }
  };

  return (
    <div className="page-white">
      {/* 헤더 */}
      <div style={{
        background: 'linear-gradient(135deg, #FF6B35 0%, #FF8C5A 100%)',
        padding: '20px 20px 24px',
      }}>
        <button
          onClick={() => navigate(-1)}
          style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 10, padding: '8px 12px', color: 'white', cursor: 'pointer', marginBottom: 12 }}
        >
          ← 뒤로
        </button>
        <div style={{ color: 'white', fontSize: 22, fontWeight: 800, marginBottom: 4 }}>
          🚐 서비스 선택
        </div>
        <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 14 }}>
          어떤 서비스가 필요하신가요?
        </div>
      </div>

      <div style={{ padding: '20px 20px 100px' }}>
        {services.map(svc => (
          <div
            key={svc.id}
            onClick={() => handleSelect(svc.id)}
            style={{
              background: selected === svc.id ? svc.bgColor : 'white',
              border: `2px solid ${selected === svc.id ? svc.color : '#E5E7EB'}`,
              borderRadius: 16, padding: '18px', marginBottom: 14,
              cursor: 'pointer', transition: 'all 0.2s',
              boxShadow: selected === svc.id ? `0 4px 16px ${svc.color}30` : '0 2px 8px rgba(0,0,0,0.04)',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
              <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <div style={{
                  width: 52, height: 52, borderRadius: 14,
                  background: svc.bgColor, display: 'flex', alignItems: 'center',
                  justifyContent: 'center', fontSize: 26, border: `1px solid ${svc.color}30`
                }}>
                  {svc.icon}
                </div>
                <div>
                  <div style={{ fontWeight: 800, fontSize: 16, color: '#1F2937' }}>
                    {svc.title}
                  </div>
                  <div style={{ fontSize: 12, color: '#6B7280', marginTop: 2 }}>
                    {svc.subtitle}
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
                {svc.badge && (
                  <span style={{
                    background: svc.color, color: 'white', padding: '3px 10px',
                    borderRadius: 20, fontSize: 11, fontWeight: 700
                  }}>{svc.badge}</span>
                )}
                <div style={{
                  width: 24, height: 24, borderRadius: '50%',
                  background: selected === svc.id ? svc.color : '#E5E7EB',
                  display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                  {selected === svc.id && (
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                      <polyline points="20 6 9 17 4 12"/>
                    </svg>
                  )}
                </div>
              </div>
            </div>

            <p style={{ fontSize: 13, color: '#4B5563', lineHeight: 1.6, marginBottom: 10 }}>
              {svc.desc}
            </p>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
              {svc.features.map((f, i) => (
                <span key={i} style={{
                  background: svc.bgColor, color: svc.color, padding: '4px 10px',
                  borderRadius: 20, fontSize: 11, fontWeight: 600
                }}>✓ {f}</span>
              ))}
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 13, fontWeight: 700, color: svc.color }}>💰 {svc.price}</span>
              <span style={{ fontSize: 12, color: '#9CA3AF' }}>⏱ {svc.estimatedTime}</span>
            </div>
          </div>
        ))}

        {/* 다음 버튼 */}
        <button
          onClick={handleNext}
          disabled={!selected}
          style={{
            width: '100%', padding: '16px', borderRadius: 16,
            background: selected ? '#FF6B35' : '#E5E7EB',
            color: selected ? 'white' : '#9CA3AF',
            border: 'none', fontWeight: 800, fontSize: 16, cursor: selected ? 'pointer' : 'not-allowed',
            transition: 'all 0.2s',
            boxShadow: selected ? '0 4px 16px rgba(255,107,53,0.4)' : 'none'
          }}
        >
          {selected ? '다음 단계로 →' : '서비스를 선택해 주세요'}
        </button>
      </div>
    </div>
  );
};

export default ServiceSelectPage;
